import { useFormContext } from "react-hook-form";
import Field, { FieldError } from "./form/Field";
import { states } from "../utils/RegistrationUtils";

const flightFields = [
  {
    leg: "arrivialInformation",
    title: "Arrival flight",
    fields: [
      ["arrivalFlightNumber", "Flight number"],
      ["arrivalDate", "Date"],
      ["arrivalTime", "Landing time"],
    ],
  },
  {
    leg: "departureInformation",
    title: "Departure flight",
    fields: [
      ["departureFlightNumber", "Flight number"],
      ["departureDate", "Date"],
      ["departureTime", "Departure time"],
    ],
  },
];

export default function ParentInfoSection() {
  const { register, watch } = useFormContext();
  const watchFlying = watch("guardianInformation.camperFlying", false);
  const g = "guardianInformation";
  const required = { required: true };

  return (
    <>
      <div className="reg-grid">
        <Field
          name={`${g}.motherName`}
          label="Mother's name"
          autoComplete="off"
          rules={{ ...required, maxLength: 50 }}
        />
        <Field
          name={`${g}.motherNumber`}
          label="Mother's phone"
          type="tel"
          autoComplete="off"
          rules={{ ...required, maxLength: 15 }}
        />
        <Field
          name={`${g}.fatherName`}
          label="Father's name"
          autoComplete="off"
          rules={{ ...required, maxLength: 50 }}
        />
        <Field
          name={`${g}.fatherNumber`}
          label="Father's phone"
          type="tel"
          autoComplete="off"
          rules={{ ...required, maxLength: 15 }}
        />
      </div>

      <Field
        name={`${g}.email`}
        label="Email"
        type="email"
        autoComplete="email"
        hint="We'll send your confirmation and payment instructions here."
        rules={{
          ...required,
          maxLength: 35,
          pattern: {
            value: /^\S+@\S+\.\S+$/,
            message: "Enter an email like name@example.com.",
          },
        }}
      />

      <Field
        name={`${g}.streetAddress`}
        label="Home street address"
        autoComplete="street-address"
        rules={{ ...required, maxLength: 50 }}
      />
      <div className="reg-grid reg-grid--address">
        <Field
          name={`${g}.city`}
          label="City"
          autoComplete="address-level2"
          rules={{ ...required, maxLength: 50 }}
        />
        <Field
          as="select"
          name={`${g}.state`}
          label="State"
          placeholder="State"
          options={states.map((s) => ({ value: s, label: s }))}
          rules={required}
        />
        <Field
          name={`${g}.zip`}
          label="ZIP code"
          type="text"
          inputMode="numeric"
          autoComplete="postal-code"
          rules={{ ...required, maxLength: 8 }}
        />
      </div>

      <fieldset className="reg-choice">
        <legend>Is your camper flying in?</legend>
        <div className="reg-choice__options reg-choice__options--inline">
          {[
            ["yes", "Yes"],
            ["no", "No, we're driving"],
          ].map(([value, label]) => (
            <label key={value} className="reg-option">
              <input
                type="radio"
                value={value}
                {...register(`${g}.camperFlying`, { required: "Choose yes or no." })}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
        <FieldError name={`${g}.camperFlying`} />
      </fieldset>

      {watchFlying === "yes" && (
        <div className="reg-flights">
          <p>
            Add flight details if you have them. If not, we'll reach out for
            them before camp.
          </p>
          {flightFields.map(({ leg, title, fields }) => (
            <div key={leg} className="reg-flight">
              <h4>{title}</h4>
              <div className="reg-grid reg-grid--3">
                {fields.map(([key, label]) => (
                  <Field
                    key={key}
                    name={`${g}.flightInformation.${leg}.${key}`}
                    label={label}
                    rules={{ maxLength: 50, shouldUnregister: true }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export function PaymentSection() {
  const { register } = useFormContext();
  const options = [
    ["zelle", "Zelle", "Send to houstonsikhyouthcamp@gmail.com"],
    ["venmo", "Venmo", "Send to @HoustonSikhYouthCamp"],
    ["check", "Check", "Make it out to Sikh Center of Gulf Coast"],
    ["cash", "Cash", "Instructions come in your confirmation email"],
  ];

  return (
    <fieldset className="reg-choice">
      <legend className="reg-visually-hidden">How will you pay?</legend>
      <div className="reg-choice__options">
        {options.map(([value, label, detail]) => (
          <label key={value} className="reg-option reg-option--detailed">
            <input
              type="radio"
              value={value}
              {...register("guardianInformation.camperPayment", {
                required: "Choose how you'll pay.",
              })}
            />
            <span>
              <strong>{label}</strong>
              {detail}
            </span>
          </label>
        ))}
      </div>
      <FieldError name="guardianInformation.camperPayment" />
    </fieldset>
  );
}
